import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BalanceModificationTransactionsEditDialog from './BalanceModificationTransactionsEditDialog';
import InternalRepatriationCreateFormDialog from '../../../../../reporting/internal-repatriation/containers/InternalRepatriationCreateFormDialog';

class BalanceModificationTransactionsEdit extends Component {
  render() {
    return (
      <div>
        <BalanceModificationTransactionsEditDialog
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          refreshTransactions={this.props.refreshTransactions}
          refreshHistories={this.props.refreshHistories}
        />
      </div>
    );
  }
}

BalanceModificationTransactionsEdit.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

export default BalanceModificationTransactionsEdit;
